// src/data/introData.js
import imagePaths from '../assets/imagePaths';

const introData = [
    {

        content: {
            images_path: imagePaths.diamond_img,
            // heading: 'Made with by',
            subheading: 'Made with by',
            listItems: []
        }
    },
    {

        content: {
            images_path: imagePaths.intro2,
            heading: 'Organize Your Projects',
            listItems: ['Built-in timers for each project.', 'Track completed projects, diamonds placed, and hours logged.', 'Filter by date, design, artist, brand, or diamond shape.', 'Categorize as Completed, In Progress, or Not Started.']
        }
    },
    {

        content: {
            images_path: imagePaths.intro3,
            heading: 'Leaderboard Rewards',
            listItems: ['Earn points by completing kits.', 'Compete for $500 in prizes every 2 months!', 'Showcase achievements & bragging rights.', 'Track progress on the live leaderboard.']
        }
    },
    {
        content: {
            images_path: imagePaths.intro4,
            heading: 'Barcode Scan',
            listItems: ['Scan Dreamer Designs barcodes to import projects.', 'Skip manual entry—just scan & start!', 'Instant project integration & updates.']
        }
    },
    {

        content: {
            images_path: imagePaths.intro4,
            heading: 'Shuffle Feature',
            subheading: 'Not sure which project to start next?',
            listItems: ['Stuck? Let shuffle pick a project!', 'Spin like a slot machine for random selection.', 'Add excitement to your crafting routine!']
        }
    },
];

export default introData;
